export default function (input) {
  return input.toUpperCase()
}
